export default class LoadingView {
  constructor({
    log,
    element,
  }) {
    this.log = log
    this.element = element
  }

  show() {
    this.element.classList.remove("dn")
    this.element.style.display = "block"
  }

  hide() {
    this.element.classList.remove("db")
    this.element.style.display = "none"
  }
}
